import { motion } from "framer-motion";
import { business } from "@/config/site";

export const Loader = ({ hidden }) => (
  <div
    data-testid="page-loader"
    aria-hidden={hidden}
    style={{
      opacity: hidden ? 0 : 1,
      pointerEvents: hidden ? "none" : "auto",
      transition: "opacity 0.7s ease",
    }}
    className="fixed inset-0 z-[10000] flex items-center justify-center bg-maroon"
  >
    <div className="text-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="text-champagne text-xs tracking-[0.4em] uppercase mb-4">
          {business.poweredBy}
        </p>
        <h1 className="font-display text-white text-4xl sm:text-6xl italic">
          {business.name}
        </h1>
      </motion.div>
      <motion.div
        className="mx-auto mt-8 h-px bg-champagne/60"
        initial={{ width: 0 }}
        animate={{ width: 160 }}
        transition={{ duration: 1.4, ease: "easeInOut" }}
      />
    </div>
  </div>
);
